import React = require('react');
import { AdmiralCardAnswer } from '../../../Components/AdmiralCardAnswer';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Field, InjectedFormProps } from 'redux-form';
import { ButtonAsRadio } from '../../../../../../components/ButtonRadioStyle';
import { isNull } from 'lodash';
import { isNotFalse, isRequired } from '../../../../../../util/validators';
import { DeclineModal } from './DeclineModal';
import { Collapsable, ICollapsableComponent } from '../../../../../../services/quote/models';
import { setCollapsable } from '../../../../../../services/quote/reducer';

interface IImportantStatementsProps extends InjectedFormProps {
    quotationDeclaration: boolean;
    synchronousError: any;
    dispatch?: any;
    collapsable?: ICollapsableComponent
    renderDefinition?: any;
}

export const ImportantStatements = ({
                                        quotationDeclaration,
                                        change,
                                        renderDefinition,
                                        dispatch,
                                        collapsable,
                                    }: IImportantStatementsProps) => {

    const [editable, setEditable] = useState(true);
    const [showDeclineModal, setShowDeclineModal] = useState(false);

    useEffect(() => {
        if (!isNull(quotationDeclaration) && quotationDeclaration !== undefined) {
            setEditable(false)
        }
    }, [quotationDeclaration]);

    const onChangeEdit = (isEditable) => {
        setEditable(isEditable)
        change('quotationDeclaration', null);
    }

    const onChangeCollapse = () => {
        dispatch(setCollapsable(null, Collapsable.IMPORTANT_STATEMENT));
    }

    const handleAnswerChange = (value) => {
        if (!value) {
            setShowDeclineModal(true)
        }
        if (value) {
            dispatch(setCollapsable(Collapsable.IMPORTANT_STATEMENT, Collapsable.ABOUT_YOU));
        }
        setEditable(false)
    }

    const closeModal = () => {
        setShowDeclineModal(false);
    }

    const renderModalBody = () => {
        return (
            <div style={{ padding: '15px 0 15px 0' }}>
                <div>Based on your answers, we are unable to offer you travel insurance.</div>
                <div>Please review your quote details to ensure that you've answered correctly.</div>
            </div>
        )
    }

    const content = () => {
        return (
            <Row>
                <Col xs={12}><strong>All named travellers:</strong></Col>
                <Col xs={12}>
                    <ul style={{ marginLeft: '20px' }}>
                        <li>are a permanent UK
                            resident {renderDefinition('', '**Are a permanent UK resident**\n\n You have your only or main home in the UK and have not spent more than six months outside the UK in the year before taking out (or renewing) this policy.')}</li>
                        <li>are registered with a GP in the UK</li>
                        <li>are unaware of any reasons why a planned trip will be cut short or cancelled</li>
                        <li>are not currently travelling</li>
                        <li>will depart from, and return to, the UK</li>
                    </ul>
                </Col>
                <Col xs={12}><strong>Are all of these statements true?</strong></Col>
            </Row>
        )
    }

    const renderButtons = () => {
        return (
            <>
                <div className={'button-container'}>
                    <div className={'box--half'}>
                        <Field
                            name={'quotationDeclaration'}
                            simpleValue={true}
                            className={'admiral-yes-no-answer-btn'}
                            secondaryClass={'admiral-yes-no-answer-btn'}
                            selectedText={'YES'}
                            unSelectedText={'YES'}
                            isBlock={true}
                            validate={[isRequired, isNotFalse]}
                            component={ButtonAsRadio}
                            handleChange={handleAnswerChange}
                        />
                    </div>
                    <div className={'box--half'}>
                        <Field
                            name={'quotationDeclaration'}
                            simpleValue={false}
                            className={'admiral-yes-no-answer-btn'}
                            secondaryClass={'admiral-yes-no-answer-btn'}
                            selectedText={'NO'}
                            unSelectedText={'NO'}
                            isBlock={true}
                            validate={[isRequired, isNotFalse]}
                            component={ButtonAsRadio}
                            handleChange={handleAnswerChange}
                        />
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <AdmiralCardAnswer
                icon={'quote-summary.svg'}
                title={'Important statements'}
                editMode={editable}
                handleEdit={onChangeEdit}
                answerSelected={quotationDeclaration}
                approvedPositiveText={'Yes, all statements are true'}
                approvedNegativeText={'No, some statements are not true'}
                infoTextAsBanner={false}
                infoText={'Please check these important statements about the travellers and trips.'}
                infoTextSuccess={'You\'ve checked these important statements about the travellers and trips.'}
                collapsable={collapsable.importantStatement}
                handleCollapse={onChangeCollapse}
            >
                {content()}
            </AdmiralCardAnswer>
            <div style={{ backgroundColor: '#FFFFFF' }}>
                {editable && renderButtons()}
            </div>
            <DeclineModal
                showDeclineModal={showDeclineModal}
                title={'Unable to continue'}
                closeButtonText={'RETURN TO QUOTE'}
                body={renderModalBody()}
                onCloseModal={closeModal}/>
        </>
    )
}
